"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// increment a person type by one if possible
function inc(store, key) {
    switch (key) {
        case 'adults':
            if (store.getters['canIncrementAdults']) {
                store.commit('INC', key);
            }
            return;
        case 'juveniles':
            if (store.getters['canIncrementJuveniles']) {
                store.commit('INC', key);
            }
            return;
        case 'children':
            if (store.getters['canIncrementChildren']) {
                store.commit('INC', key);
            }
    }
}
exports.inc = inc;
// decrements a person type by one if possible, but keeps 1 fullAged person
function dec(store, key) {
    if (store.getters['fullAged'] === 1) {
        if (key === 'adults' && store.state.adults === 1) {
            store.commit('SWAP');
        }
        else if (key === 'juveniles' && store.state.juveniles === 1) {
            store.commit('SWAP');
        }
        else {
            // store.commit('DEC', key)
            switch (key) {
                case 'adults':
                    if (store.getters['canDecrementAdults']) {
                        store.commit('DEC', key);
                    }
                    return;
                case 'juveniles':
                    if (store.getters['canDecrementJuveniles']) {
                        store.commit('DEC', key);
                    }
                    return;
                case 'children':
                    if (store.getters['canDecrementChildren']) {
                        store.commit('DEC', key);
                    }
            }
        }
    }
    else {
        switch (key) {
            case 'adults':
                if (store.getters['canDecrementAdults']) {
                    store.commit('DEC', key);
                }
                return;
            case 'juveniles':
                if (store.getters['canDecrementJuveniles']) {
                    store.commit('DEC', key);
                }
                return;
            case 'children':
                if (store.getters['canDecrementChildren']) {
                    store.commit('DEC', key);
                }
        }
    }
}
exports.dec = dec;
// lock the store if unlocked
function lock(store) {
    if (!store.getters['locked']) {
        store.commit('LOCK');
    }
}
exports.lock = lock;
// unlock the store if locked
function unlock(store) {
    if (store.getters['locked']) {
        store.commit('UNLOCK');
    }
}
exports.unlock = unlock;
function resetStore(store) {
    store.commit('RESET_STATE');
}
exports.resetStore = resetStore;
// export everything compliant to the vuex specification for actions
exports.default = {
    inc: inc, dec: dec, lock: lock, unlock: unlock,
    resetStore: resetStore
};
//# sourceMappingURL=actions.js.map